module.exports = __webpack_public_path__ + "static/media/call_send_chat.86605f78.svg";